import React from "react";
import { Navigate, Route } from "react-router-dom";

import { NotFoundPage } from "../../components/errors/NotFoundPanel";
import { AuthenticatedMainView } from "../../features/main/AuthenticatedMainView";
import { PortalCode } from "../../features/portal/pages/PortalCode";
import { PortalHome } from "../../features/portal/pages/PortalHome";
import { PortalInvite } from "../../features/portal/pages/PortalInvite";
import { PortalRequest } from "../../features/portal/pages/PortalRequest";
import { PortalRequestLink } from "../../features/portal/pages/PortalRequestLink";
import { PortalSign } from "../../features/portal/pages/PortalSign";
import { PortalSignIn } from "../../features/portal/pages/PortalSignIn";
import { PortalSignLink } from "../../features/portal/pages/PortalSignLink";
import { AccountSetupPage } from "../../features/onboarding/journey/AccountSetupPage";
import UserInvite from "../../features/UserInvite/UserInvite";
import { invisibleRouteMap, sideNavRouteMap } from "./SidenavRouteMaps";

export const MainRoute = () => {
  const sidebarRoutes = sideNavRouteMap.map((routeElement) => {
    const { path, component: Component } = routeElement;
    return (
      <Route
        key={`component-${path}-key`}
        path={`${path}/*`}
        element={<Component />}
      />
    );
  });

  const invisibleRoutes = invisibleRouteMap.map((routeElement) => {
    const { name, component: Component } = routeElement;
    return (
      <Route
        key={`component-${name}-key`}
        path={`${name}/*`}
        element={<Component />}
      />
    );
  });

  return (
    <>
      <Route element={<AuthenticatedMainView />}>
        <Route index element={<Navigate to={"./home"} replace={true} />} />
        {sidebarRoutes}
        {invisibleRoutes}
        {/* Unknown address: friendly page inside the app (QA SEC-006). */}
        <Route path={"*"} element={<NotFoundPage />} />
      </Route>
      <Route path={"/user-invitations/:id"} element={<UserInvite />} />
      {/* New firm owner: choose the password from the welcome email (2026-10-25). */}
      <Route path={"/setup/:token"} element={<AccountSetupPage />} />
      {/* Client portal: clients sign in here with the portal's own sign-in, not the firm's. */}
      <Route path={"/portal"} element={<PortalSignIn />} />
      <Route path={"/portal/code"} element={<PortalCode />} />
      <Route path={"/portal/invite/:token"} element={<PortalInvite />} />
      <Route path={"/portal/home"} element={<PortalHome />} />
      <Route path={"/portal/sign/:token"} element={<PortalSignLink />} />
      <Route path={"/portal/signatures/:id"} element={<PortalSign />} />
      <Route path={"/portal/request/:token"} element={<PortalRequestLink />} />
      <Route path={"/portal/requests/:id"} element={<PortalRequest />} />
    </>
  );
};
